<template>
  <v-row justify="center" align="center" dense>
    <v-col cols="auto" v-for="selfie in selfies" v-bind:key="selfie.id">
      <WallEntry :selfie="selfie" :expanded="expanded" :p-hashtag="pHashtag" />
    </v-col>
  </v-row>
</template>

<script>
import WallEntry from "./WallEntry";

export default {
  name: "WallContent",
  components: { WallEntry },
  data() {
    return {
      fab: false,
      chevron: true,
    };
  },
  methods: {},

  props: {
    selfies: null,
    pHashtag: String,
    expanded: {
      type: Boolean,
    },
  },
};
</script>

<style scoped lang="scss"></style>
